

<!-- <div *ngIf="!isPrint" class="container pt-0 pb-0">
    <div class="row">
        <div class="col-12 text-end">
            <button class="btn btn-secondary ms-3 text-white" (click)="printPage();"><i class="bi bi-printer text-white"></i></button>

            <button class="btn btn-secondary ms-3 text-white" (click)="downloadPdf();"><i class="bi bi-file-earmark-pdf text-white"></i></button>

        </div>
    </div>
</div> -->


<div  id="exportpdf">
<div class="container">

    <div class="row">
        <div class="col-12 text-center">
            <br><br><br><br>
            <h3><b><u>DETAIL QUOTATION</u></b></h3>
        </div>

        <div class="col-12"><br><br></div>

        <div class="col-3 text-end">
            <div *ngIf="companyBase64">
                <img src="{{companyBase64}}" style="max-width: 80; max-height:80px;">
            </div>
            <div *ngIf="!companyBase64">
                <svg width="120" height="120">
                    <rect width="120" height="120" 
                    style="fill:rgb(217,217,217);stroke-width:0;stroke:rgb(0,0,0)" />
                  Sorry, your browser does not support inline SVG.
                </svg>
            </div>
            <!-- <svg width="120" height="120">
                <rect width="120" height="120" 
                style="fill:rgb(217,217,217);stroke-width:0;stroke:rgb(0,0,0)" />
              Sorry, your browser does not support inline SVG.
            </svg> -->
        </div>
        <div class="col-4">
            <b>{{companyName}}</b>
            <b>{{DataQuotation?.procurementDetailAddress?.companyName}}</b><br>
  


            <font [innerHTML]="companyAddress"></font>
            <br>

        </div>
        <div class="col-1">

        </div>
        <div class="col-4">
            Phone : {{ (companyPhone) ? companyPhone :'-' }}<br>
            Email : {{ (companyEmail) ? companyEmail :'-' }}
        </div>

        <div class="col-12"><br></div>

        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                    Payment Term
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                    {{(DataQuotation?.paymentTermOfferedInDays) ? DataQuotation?.paymentTermOfferedInDays+' Days':'-'}}
                </div>
            </div>
        </div>
        <div class="col-2"></div>
        <div class="col-5 p-2">
            <div class="row g-0">
                <div class="col-12 ps-2 pe-2 text-end">
                    <b><u>RFQ Id : # {{formatDisplayId(DataRfq?.rfqDisplayId)}}</u></b>
                </div>
            </div>
            
        </div>

        <div class="col-12 p-1"></div>

        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                    currency
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                    {{ DataRfq?.currency }}
                </div>
            </div>
        </div>
        <div class="col-2"></div>
        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                    Date
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                    {{DataQuotation?.createdDate | date:'d MMM y'}}
                </div>
            </div>
        </div>

        <div class="col-12 p-1"></div>

        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                    Procurement Internal Ref. No.
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                    {{ (DataQuotation?.vendorRefNumber)?DataQuotation?.vendorRefNumber:'-' }}
                </div>
            </div>
        </div>
        <div class="col-2"></div>
        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                    ETA Offered
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                    <font *ngIf="DataQuotation?.etaOffered">{{DataQuotation?.etaOffered | date:'d MMM y'}}</font>
                    <font *ngIf="!DataQuotation?.etaOffered">-</font>
                </div>
            </div>
        </div>

        <div class="col-12 p-1"><br></div>

        <div class="col-5">
            <table class="table p-2">
                <tr>
                    <td style="background-color: #000000;color: #ffffff;"><h5 class="p-0">
                        <!-- Vendor Company -->
                        {{DataRfq?.procurementName}}
                    </h5></td>
                </tr>
                <tr>
                    <td style="border: solid 1px #f0f0f0;">
                       {{DataRfq?.rfqDeliveryStreet}}  <br>  
                       {{DataRfq?.rfqDeliveryProvince}} <br>  
                       {{DataRfq?.rfqDeliveryProvince}} <br>  
                       {{DataRfq?.rfqDeliveryCity}} {{DataRfq?.rfqDeliveryCity}}  <br>   
                       {{DataRfq?.rfqDeliveryCountry}}         
                       

       

                    </td>
                </tr>
            </table>
        </div>
        <div class="col-2"></div>
        <div class="col-5">
            <table class="table">
                <tr>
                    <td style="background-color: #000000;color: #ffffff;"><h5 class="p-0">Shipping Detail</h5></td>
                </tr>
                <tr>
                    <td style="border: solid 1px #f0f0f0;">{{ DataQuotation?.quotationDeliveryCity ? DataQuotation?.quotationDeliveryCity+ " , ":"" }} {{ DataQuotation?.quotationDeliveryCountry}}      
                    </td>
                </tr>
            </table>
        </div>

        <div class="col-12"><br></div>

        <div class="col-12">
            <table class="table">
                <tr>
                    <th style="border: solid 1px #f0f0f0;background-color: #000000;color: #ffffff;">
                        <b>#</b>
                    </th>
                    <th  width="140px" style="border: solid 1px #f0f0f0;background-color: #000000;color: #ffffff;">
                        <b>Manf. Code.</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #000000;color: #ffffff;">
                        <b>Brand</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #000000;color: #ffffff;">
                        <b>Product Name</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #000000;color: #ffffff;">
                        <b>Product Description</b>
                    </th>
                    <th width="100px" style="border: solid 1px #f0f0f0;background-color: #000000;color: #ffffff;">
                        <b>QTY Offer</b>
                    </th>
                    <th width="140px" style="border: solid 1px #f0f0f0;background-color: #000000;color: #ffffff;">
                        <b>Price</b>
                    </th>
                    <th width="140px" style="border: solid 1px #f0f0f0;background-color: #000000;color: #ffffff;">
                        <b>Line Total</b>
                    </th>
                </tr>


                <tr *ngFor="let product of DataQuotation?.quotationItem; let i = index">
  
      
                    <td style="border: solid 1px #f0f0f0;">{{ i+1 }}</td>
                    <td style="border: solid 1px #f0f0f0;">{{ product.productManufacturerCode }}</td>
                    <td style="border: solid 1px #f0f0f0;">{{ product.productBrandOffered }}</td>
                    <td style="border: solid 1px #f0f0f0;">{{ product.productNameOffered }}</td>
                    <td style="border: solid 1px #f0f0f0;">{{ divDetailspec(product.productDescOffered) }}</td>
                    <td style="border: solid 1px #f0f0f0;text-align: right;">{{ product.qtyOffered | number }}</td>
                    <td style="border: solid 1px #f0f0f0;text-align: right;">{{ DataRfq?.currency }} {{ product.priceOffered | number }}</td>
                    <td style="border: solid 1px #f0f0f0;text-align: right;">{{ DataRfq?.currency }} {{ product.qtyOffered * product.priceOffered | number }}</td>
                </tr>



            </table>
        </div>

        <div class="col-5">
            <div class="p-2" style="background-color: #f0f0f0;">
                <b>Offer memo to Customer</b>
              <br>
              {{DataQuotation?.memo}}
                <br>
            </div>
        </div>
        <div class="col-2"></div>
        <div class="col-5 text-end">
            <table class="table">
                <tr *ngIf="!DataQuotation?.isTaxIncluded">
                    <td style="border:0px;text-align:right;">
                        Subtotal
                    </td>
                    <td style="border:0px;text-align:right;">
                        {{ DataRfq?.currency }} {{totalQuotationPrice | number}}
                    </td>
                </tr>
                <tr *ngIf="!DataQuotation?.isTaxIncluded">
                    <td style="border:0px;text-align:right;">

                        <ng-container *ngIf="DataQuotation?.taxValue">Tax</ng-container>
                        <ng-container *ngIf="DataQuotation?.taxPercentage">Tax({{DataQuotation?.taxPercentage}}%)</ng-container>

                    </td>
                    <td style="border:0px;text-align:right;">
                        
                        <ng-container *ngIf="DataQuotation?.taxValue">{{ DataRfq?.currency }} {{DataQuotation?.taxValue | number}}</ng-container>
                        <ng-container *ngIf="DataQuotation?.taxPercentage">{{ DataRfq?.currency }} {{DataQuotation?.taxPercentage * totalQuotationPrice /100 | number}}</ng-container>

                    </td>
                </tr>
                <tr>
                    <td  style="border:0px;text-align:right;" class="fw-bold" >
                        Total
                    </td>
                    <td class="fw-bold" style="border:0px;text-align:right;">
                        
                        <!-- <ng-container *ngIf="DataQuotation?.getValueTax">{{ DataRfq?.currency }} {{totalQuotationPrice + getValueTax | number}}</ng-container>
                        <ng-container *ngIf="DataQuotation?.vendorTaxPercentage">{{ DataRfq?.currency }} {{totalQuotationPrice + (DataQuotation?.vendorTaxPercentage * totalQuotationPrice /100) | number}}</ng-container> -->

                        <ng-container *ngIf="DataQuotation?.taxValue">
                            {{ DataRfq?.currency }} {{totalQuotationPrice + DataQuotation?.taxValue | number}}
                        </ng-container>
                        <ng-container *ngIf="DataQuotation?.taxPercentage">
                            {{ DataRfq?.currency }} {{totalQuotationPrice + (DataQuotation?.taxPercentage * totalQuotationPrice /100) | number}}
                        </ng-container>
                        <ng-container *ngIf="DataQuotation?.isTaxIncluded">
                            {{ DataRfq?.currency }} {{totalQuotationPrice | number}}
                        </ng-container>

                    </td>
                </tr>
            </table>
        </div>

        <div class="col-12">
            <br>
            <br>
            <!-- This document is submitted by (_________) on (__/__/____  __:__)
            <br> -->

            

            <ng-container *ngIf="DataQuotation?.state !== 'UNPUBLISHED'">
                This document is updated on {{DataQuotation?.modifiedDate  | date:'d MMM y'}}
            </ng-container>            
            
            <br><br>
            ** QUOTATION {{DataQuotation?.state}} **


            <br>
            <br>
            <br>
            <br><br>
        </div>
    </div>





</div>
</div>